// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1b_CK","buttons":"SendReceipts_buttons__3c7uY","email":"SendReceipts_email__1ezI3","bookApptTitle":"SendReceipts_bookApptTitle__NMgbX"};